const styles = {
  page: {
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Roboto",
    fontSize: 10,
    lineHeight: 1.5,
    padding: "20 30 20 50"
  },
  cdkLogo: {
    marginLeft: "70%",
    marginTop: -20,
  },
  header: {
    fontWeight: "medium",
    marginTop: 5,
    textAlign: "center"
  },
  headerTitleWithUnderline: {
    fontWeight: "medium",
    textDecoration: "underline"
  },
  table: {
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRightWidth: 0,
    borderStyle: "solid",
    display: "table",
    width: "auto"
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    borderWidth: 1,
    borderLeftWidth: 0,
    borderStyle: "solid",
    borderTopWidth: 0,
    width: "20%"
  },
  tableCell: {
    margin: "auto",
    fontSize: 10,
    padding: 3,
    paddingTop: 5
  },
  tableCellWithoutAutoMargin: {
    fontSize: 10,
    padding: 3,
    paddingTop: 5
  },
  flexColumnFlexStart: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start"
  },
  flexRowSpaceBetween: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  declarationPlaceDateStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginTop: 20,
    width: "30%"
  },
  declarationSignature: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    marginTop: 20,
    width: "50%"
  },
  fontBold: {
    fontWeight: "medium"
  },
  textLight: {
    fontWeight: "light"
  },
  textItalic: {
    fontStyle: "italic",
    fontWeight: 300
  },
  textCenter: {
    textAlign: "center"
  },
  textLeft: {
    textAlign: "left"
  },
  textUnderline: {
    textDecoration: "underline"
  },
  width60: { width: "60%" },
  marginTop20: {
    marginTop: 20
  },
  paddingLeft10: {
    paddingLeft: 10
  },
  paddingLeft60: {
    paddingLeft: 60
  },
  paddingBottom10: {
    paddingBottom: 10
  },
  paddingRight130: {
    paddingRight: 130
  },
  hrLine: {
    borderTop: 1
  },
  borderRight: {
    borderRight: 1
  },
  flexDirectionRow: {
    flexDirection: "row"
  },
  displayFlex: {
    display: "flex"
  },
  autoMargin: {
    margin: "auto"
  },
  textBlack: {
    color: "black"
  },
  textRed: {
    color: "red"
  },
  flexDisplay: {
    display: "flex"
  },
  width10: {
    width: "10%"
  },
  width20: { width: "20%" },
  width25: { width: "25%" },
  width30: { width: "30%" },
  width50: { width: "50%" },
  width100: { width: "100%" },
  marginTop10: {
    marginTop: 10
  },
  marginLeft40: {
    marginLeft: 40
  },
  marginLeft50: {
    marginLeft: 50
  },
  marginRight90: {
    marginRight: 90
  },
  horizontalLine: {
    borderTop: 2
  }
};

export default styles;
